<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace" id="epi"> </p>
<p class="ep">Some there be that shadows kiss</p>
<p class="ep-bot">Such have but a shadow’s bliss.</p>
<p class="epc">—Shakespeare<br/><span class="epub-i">The Merchant of Venice</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?7e98978e